import { useDispatch, useSelector } from "react-redux";
import {updateFilters, deleteFilters} from "store/filters/operations";
import { selectFilters } from "store/filters/selectors";
import { DropdownMenu } from "reusableComponents";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

const CapacityFilterButton = ({ onCapacitySelect }) => {
  const dispatch = useDispatch();
  const filters = useSelector(selectFilters);
  const [t] = useTranslation("global");

  const getCapacities = () => {
    const caps = [];
    caps.push({ label: t("searchBar.persPlaceholder"), value: null }); // Reset option

    if (filters?.usages?.includes("conference_room")) {
      caps.push({ label: "100-200", value: "100-200" });
      caps.push({ label: "200-500", value: "200-500" });
      caps.push({ label: "500+", value: "500+" });
    } else {
      for (let i = 1; i <= 100; i++) {
        caps.push({ label: i === 100 ? "100+" : `${i}`, value: i === 100 ? "100+" : i });
      }
    }

    return caps;
  };

  const capacityOptions = getCapacities();

  const handleCapacityChange = (option) => {
    // If the selected option is null, delete the capacity filter
    if (option.value === null) {
      dispatch(deleteFilters("capacity"));
    } else {
      // Otherwise, update the capacity filter with the selected value
      dispatch(updateFilters({ capacity: option.value }));
    }
    
    // Call the optional callback if provided
    if (onCapacitySelect) {
      onCapacitySelect();
    }
  };

  // Find the currently selected capacity option
  const selectedCapacity =
    capacityOptions.find(
      (option) => String(option.value) === String(filters.capacity)
    ) || null; // Fallback to null if no match is found

  return (
    <DropdownMenu
      defaultText={t("searchBar.persPlaceholder")}
      options={capacityOptions}
      selectedOption={selectedCapacity}
      onOptionSelect={handleCapacityChange}
    />
  );
};

export default CapacityFilterButton;
